import VideoGuide from './video-guide';

export default VideoGuide;
